const transactionStatuses = {
  waiting_payment: 'Aguardando pagamento',
  paid: 'Paga',
  refused: 'Pagamento recusado',
}

export default transactionStatuses
